import * as pubnubNotificationService from '@/services/pubnubNotificationService';
import * as React from 'react';
import { getBidderId, getSessionId } from '@/redux/modules/user';
import { useDispatch, useSelector } from 'react-redux';
import { createPubnubBidderNotificationsOnMessageReceived } from '@/redux/modules/notification';
import { getPubnubNotificationsSubscribeKey } from '@/redux/modules/config';
import { PubnubMessage } from '@/types/pubnub';

const PubnubBidderNotificationContainer = () => {
    const dispatch = useDispatch();
    const subscribeKey = useSelector(getPubnubNotificationsSubscribeKey);
    const bidderId = useSelector(getBidderId);
    const sessionId = getSessionId();
    const channel = bidderId < 0 ? null : `Notification.${bidderId}`;

    const onMessage = React.useCallback(
        // Push new message to event queue processor
        (pubnubEvent: PubnubMessage) =>
            dispatch(createPubnubBidderNotificationsOnMessageReceived(bidderId)(pubnubEvent)),
        [bidderId, dispatch]
    );

    const [pubnubChannel, setPubnubChannel] = React.useState(null);

    const connectToPubnub = React.useCallback(async () => {
        if (
            pubnubChannel &&
            pubnubChannel.channel &&
            pubnubChannel.channel.includes &&
            pubnubChannel.channel.includes(bidderId)
        ) {
            return;
        }
        if (Boolean(channel) && Boolean(sessionId) && Boolean(subscribeKey) && bidderId > -1) {
            await pubnubNotificationService.connect(sessionId, subscribeKey);

            const newChannel = await pubnubNotificationService.subscribe(channel, onMessage, sessionId, subscribeKey);
            setPubnubChannel(newChannel);
        }
    }, [pubnubChannel, onMessage, bidderId, sessionId, subscribeKey, channel]);

    React.useEffect(() => {
        connectToPubnub();

        return () => {
            if (pubnubChannel) {
                pubnubChannel.unsubscribe();
                setPubnubChannel(null);
            }
        };
    }, []); // eslint-disable-line

    React.useEffect(() => {
        if (!pubnubChannel) {
            connectToPubnub();
        }
    }, [connectToPubnub, pubnubChannel]);

    return null;
};

export default PubnubBidderNotificationContainer;
